import { motion, AnimatePresence } from 'framer-motion'
import { CheckCircle, AlertCircle, Info, X } from 'lucide-react'
import type { Toast as ToastType } from '@/hooks/useToast'

interface ToastProps {
  toasts: ToastType[]
  onRemove: (id: string) => void
}

export function ToastContainer({ toasts, onRemove }: ToastProps) {
  return (
    <div className="fixed bottom-6 right-6 z-[100] flex flex-col gap-3">
      <AnimatePresence>
        {toasts.map((toast) => (
          <motion.div
            key={toast.id}
            initial={{ opacity: 0, x: 100, scale: 0.9 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: 100, scale: 0.9 }}
            transition={{ duration: 0.3 }}
            className={[
              'flex items-center gap-3 px-5 py-3.5 rounded-xl shadow-xl border min-w-[300px] max-w-[400px]',
              toast.type === 'success' ? 'bg-green-500/10 border-green-500/30 text-green-400' : '',
              toast.type === 'error' ? 'bg-destructive/10 border-destructive/30 text-destructive' : '',
              toast.type === 'info' ? 'bg-primary/10 border-primary/30 text-primary' : '',
            ].join(' ')}
          >
            {toast.type === 'success' && <CheckCircle className="w-5 h-5 shrink-0" />}
            {toast.type === 'error' && <AlertCircle className="w-5 h-5 shrink-0" />}
            {toast.type === 'info' && <Info className="w-5 h-5 shrink-0" />}
            <span className="text-sm font-medium flex-1">{toast.message}</span>
            <button onClick={() => onRemove(toast.id)} className="p-1 rounded hover:bg-white/10 transition-colors">
              <X className="w-4 h-4" />
            </button>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  )
}
